import React, { Fragment, useEffect, useRef, useState } from 'react';
import { ProgramRequestsTable } from '../admin/program-requests-table';
import {
    faChevronDown,
    faChevronUp,
    faPencilAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import format from 'date-fns/format';
import { UrlEnum } from '../../../../shared';
import { useHistory } from 'react-router-dom';

export const ProgramRequestInstitutionRequestCard = ({ data, cardCategoryName }) => {
    const formatCreatedDate = createdDate => {
        if (createdDate == null) return <Fragment></Fragment>;
        const date = new Date(createdDate);
        return <Fragment>{format(date, 'M/d/yyyy')}</Fragment>;
    };
    const history = useHistory();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const contentRef = useRef(null);

    const toggleCollapse = () => {
        setIsTransitioning(true);
        setIsCollapsed(!isCollapsed);
    };

    useEffect(() => {
        if (!isTransitioning) return;

        const contentEl = contentRef.current;

        if (isCollapsed) {
            // Start collapsing
            contentEl.style.height = `${contentEl.scrollHeight}px`;
            requestAnimationFrame(() => {
                contentEl.style.height = '0';
            });
        } else {
            // Start expanding
            contentEl.style.height = '0';
            requestAnimationFrame(() => {
                contentEl.style.height = `${contentEl.scrollHeight}px`;
            });
        }

        // Reset state after transition
        const handleTransitionEnd = () => {
            setIsTransitioning(false);
            contentEl.style.height = isCollapsed ? '0' : 'auto';
        };

        contentEl.addEventListener('transitionend', handleTransitionEnd);

        return () => {
            contentEl.removeEventListener('transitionend', handleTransitionEnd);
        };
    }, [isCollapsed, isTransitioning]);
    return (
        <div
            className="tab-pane fade show active"
            id="requests"
            role="tabpanel"
            aria-labelledby="requests-tab"
        >
            <div className="p-3">
                {cardCategoryName !== 'Awaiting Response' && (
                    <a
                        className={`text-body ${isCollapsed ? 'collapsed' : ''}`}
                        onClick={toggleCollapse}
                        style={{ cursor: 'pointer' }}
                    >
                        <h2 className="text-strong mb-4">
                            {cardCategoryName} ({data.length}){' '}
                            <FontAwesomeIcon
                                icon={isCollapsed ? faChevronUp : faChevronDown}
                            />
                        </h2>
                    </a>
                )}
                {cardCategoryName === 'Awaiting Response' && (
                    <h2 className="text-strong mb-4">
                        {cardCategoryName} ({data.length})
                    </h2>
                )}
                <div
                    className={`mb-5 ${
                        isTransitioning ? 'collapsing' : isCollapsed ? 'collapse' : 'show'
                    }`}
                    ref={contentRef}
                >
                    {data.map(req => (
                        <a
                            className="card request-card action mb-3"
                            onClick={() => {
                                const location = {
                                    pathname:
                                        UrlEnum.INSTITUTION_VIEW_ACADEMIC_PROGRAM_REQUESTS,
                                    state: [
                                        {
                                            data: req,
                                        },
                                    ],
                                };
                                history.push(location);
                            }}
                        >
                            <div className="row align-items-center justify-content-between">
                                <div className="col-md mb-3 mb-md-0">
                                    <p className="text-muted text-italic mb-2">
                                        {req.description} submitted{' '}
                                        {formatCreatedDate(req.createdOn)}
                                    </p>
                                    <div className="ml-2">
                                        <h2 className="text-600 text-primary mb-1">
                                            {req.programName}
                                        </h2>
                                    </div>
                                </div>
                                <div className="col-md-auto">
                                    {req.status === 'Awaiting Institution' && (
                                        <div className="d-flex align-items-center">
                                            <h2 className="mb-0 mr-4">
                                                <span className="badge badge-round badge-danger p-2">
                                                    <i className="fas fa-exclamation-circle"></i>{' '}
                                                    Action Required
                                                </span>
                                            </h2>
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary request-card-btn"
                                            >
                                                Edit
                                            </button>
                                        </div>
                                    )}
                                    {req.status === 'Submitted' && (
                                        <div className="d-flex align-items-center">
                                            <h2 className="mb-0 mr-4">
                                                <span className="badge badge-round badge-light-gray p-2">
                                                    Submitted
                                                </span>
                                            </h2>
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary request-card-btn"
                                            >
                                                Edit
                                            </button>
                                        </div>
                                    )}
                                    {req.status === 'Under Review' && (
                                        <div className="d-flex align-items-center">
                                            <h2 className="mb-0 mr-4">
                                                <span className="badge badge-round badge-light-orange p-2">
                                                    Under Review
                                                </span>
                                            </h2>
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary request-card-btn"
                                            >
                                                View
                                            </button>
                                        </div>
                                    )}
                                    {(req.status === 'Denied' ||
                                        req.status === 'Approved') && (
                                        <div className="d-flex align-items-center">
                                            <div className="d-flex align-items-center">
                                                <h2 className="mb-0 mr-4">
                                                    <span className="badge badge-round badge-light-gray p-2">
                                                        {req.status}
                                                    </span>
                                                </h2>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary request-card-btn"
                                                >
                                                    View
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};
